import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import erimg from "../../images/404/error-404.webp";
import AOS from "aos";

const Error = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 500,
      once: false,
    });
  }, []);

  return (
    <section className="error-404-section section-padding">
      <div className="container">
        <div className="row">
          <div
            className="col col-xs-12"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            <div className="content clearfix">
              <div className="error">
                <img src={erimg} alt="404 CreaSnap" fetchpriority="high" />
              </div>
              <div className="error-message">
                <h3>Oops! Halaman Tidak Ditemukan!</h3>
                <p>
                  We’re sorry but we can’t seem to find the page you requested.
                  This might be because you have typed the web address
                  incorrectly.
                </p>
                <Link
                  onClick={ClickHandler}
                  to="/"
                  className="theme-btn"
                  aria-label="Kembali Ke halaman Utama"
                >
                  {" "}
                  Back to home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Error;
